import { useState } from 'react';
import ReactPlayer from 'react-player/youtube';
import MdPlayCircleOutline from '@meronex/icons/md/MdPlayCircleOutline';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import useData from './data';
import BiArrowBack from '@meronex/icons/bi/BiArrowBack';
import { getConfig } from '../../../../utils/config';
import { LoadingSpinner } from '../../../../Components/Molecules/LoadingUI';
import Lightbox from 'yet-another-react-lightbox';
import Fullscreen from 'yet-another-react-lightbox/dist/plugins/fullscreen';
import Zoom from 'yet-another-react-lightbox/dist/plugins/zoom';
import 'yet-another-react-lightbox/dist/styles.css';
import ZeroState from '../../../../Components/Organisms/ZeroState';

export default function EventImageVideoGallery() {
    const [playVideo, setPlayVideo] = useState(false);
    const params = useParams();
    const { event, isLoading } = useData(params.eventId);
    const history = useHistory();
    const config = getConfig();
    const [index, setIndex] = useState(-1);

    const eventImages = event?.eventGallery?.map((image) => {
        let imageDetails = {
            src: image.url
        };
        return imageDetails;
    });

    const backClickHandler = () => {
        history.push('/events?returned=true');
    };
    // console.log(eventImages)
    return (
        <>
            <div
                className={`
                    ${config?.bannerNegativeTopMarginClass} z-10 w-full `}
            >
                {/* {isLoading && <LoadingSpinner />}
                {!isLoading && (
                    <img
                        src={event.plainBannerImage?.url}
                        className=" z-20 w-full h-full object-cover"
                    />
                )} */}
            </div>
            {config?.header && (
                <div className={config?.header.headerClass}></div>
            )}
            <section
                style={{
                    backgroundImage: `linear-gradient(90deg, rgba(${
                        config?.sectionBackground?.color
                    }, ${config?.sectionBackground?.opacity}), rgba(${
                        config?.sectionBackground?.color
                    }, ${config?.sectionBackground?.opacity})), url('${
                        config?.sectionBackground?.image
                            ? config?.sectionBackground?.image
                            : ''
                    }')`,
                    backgroundSize: `${
                        config?.sectionBackground?.size
                            ? config?.sectionBackground?.size
                            : '30% auto'
                    }`
                }}
                className={
                    `${
                        config?.events.eventsSection.overlayClass
                            ? 'relative'
                            : ''
                    }` + ' min-h-screen w-full'
                }
            >
                {config?.events.eventsSection.overlayClass ? (
                    <div
                        className={
                            `${config?.events.eventsSection.overlayClass}` +
                            ' absolute top-0 bottom-0 left-0 right-0 z-0'
                        }
                    ></div>
                ) : null}
                <div
                    className="z-10 flex flex-row items-center cursor-pointer"
                    onClick={backClickHandler}
                >
                    <BiArrowBack
                        className={'h-16 w-7 ml-8 text-primary z-10'}
                    />
                    <h3
                        className={`ml-2 text-primary font-semibold text-lg my-4 z-10   ${config?.events?.fontHeading}`}
                    >
                        {event.title}
                    </h3>
                </div>
                {event?.videoUrl && (
                    <div className="h-[40vh] md:h-[52vh] lg:h-[58vh] xl:h-[71vh] 2xl:h-[88vh] mx-auto text-center mb-6 lg:mb-16 w-[85%] lg:w-[70%] z-10 flex flex-col">
                        <h4
                            className={` text-black font-semibold text-lg my-4 z-10 ${config?.events?.fontHeading}  pt-12 mb-4`}
                        >
                            EVENT VIDEO
                        </h4>
                        <ReactPlayer
                            url={event.videoUrl}
                            className="react-player border-4 border-primary fixed-bottom self-center w-full z-10"
                            playIcon={
                                <div className="flex relative w-full h-full justify-center ">
                                    {/* <img
                                        className="object-cover self-center h-full w-full "
                                        src={event?.displayimage}
                                    /> */}
                                    <MdPlayCircleOutline className=" absolute self-center text-white text-9xl z-10" />
                                </div>
                            }
                            playing={playVideo}
                            light={true}
                            onClickPreview={() => {
                                setPlayVideo(true);
                            }}
                            width="100%"
                            height="100%"
                            controls={true}
                        />
                    </div>
                )}
                <div className="p-8 flex flex-col min-h-screen z-10">
                    {event?.eventGallery?.length > 0 && (
                        <>
                            <div className="flex flex-col">
                                <h4
                                    className={` text-black font-semibold text-lg my-4 z-10 ${config?.events?.fontHeading}  `}
                                >
                                    EVENT PICTURES
                                </h4>
                                <div className=" grid grid-cols-5 gap-2">
                                    {eventImages.map((image, i) => (
                                        <img
                                            onClick={() => setIndex(i)}
                                            className={` h-full w-full cursor-pointer`}
                                            src={image?.src}
                                        />
                                    ))}
                                </div>
                            </div>

                            <Lightbox
                                slides={eventImages.map((image) => {
                                    return {
                                        src: image?.src,
                                        height: null,
                                        width: null
                                    };
                                })}
                                open={index >= 0}
                                index={index}
                                close={() => setIndex(-1)}
                                plugins={[Fullscreen, Zoom]}
                            />
                        </>
                    )}

                    {!event?.videoUrl && event?.eventGallery?.length === 0 && (
                        <ZeroState type="events" />
                    )}
                </div>
            </section>
        </>
    );
}
